import {
  COMPUTE_PROGRAMMATIC_ADVICE_RECO_SIZE,
  FETCH_PROGRAMMATIC_ADVICE_RECO_FAILED,
  FETCH_PROGRAMMATIC_ADVICE_RECO_SUCCESS,
  FETCHING_PROGRAMMATIC_ADVICE_RECO,
  type Action,
} from '@/digitalAdvice/Recommendation/ProgrammaticAdviceReco.actions';
import {
  programmaticAdviceRecoInitialState,
  type ProgrammaticAdviceRecoState,
} from '@/digitalAdvice/Recommendation/ProgrammaticAdviceReco.model';

type CommonRecommendationReducer = (
  state: ProgrammaticAdviceRecoState | undefined,
  action: Action,
) => ProgrammaticAdviceRecoState;

export const commonProgrammaticAdviceRecoReducer: CommonRecommendationReducer =
  (state = programmaticAdviceRecoInitialState, action) => {
    switch (action.type) {
      case COMPUTE_PROGRAMMATIC_ADVICE_RECO_SIZE:
        return { ...state, size: action.payload };

      case FETCH_PROGRAMMATIC_ADVICE_RECO_FAILED:
        return { ...state, error: action.error.message, fetching: false };

      case FETCH_PROGRAMMATIC_ADVICE_RECO_SUCCESS:
        return { ...state, data: action.payload, fetching: false };

      case FETCHING_PROGRAMMATIC_ADVICE_RECO:
        return { ...state, fetching: true };

      default:
        return state;
    }
  };
